import { makeAutoObservable, runInAction } from 'mobx';
import router from 'next/router';
import { IRegionData, IRegionDataLanguage, TLocale } from '@typescript/index';
import NextRegionsApi from '@features/api/nextApiService/nextRegionsApi';
import getOffer from '@utils/getOffer';
// TODO: add a mechanism to identify the region and language based on the website address

class RegionsStore {
  public regions: Array<IRegionData> | null = null;
  public selectedLanguage: string | null = null;
  public currentLocale: TLocale | null = null;
  public currentOffer: string | null = null;
  public isSideBarOpen = false;
  constructor() {
    makeAutoObservable(this);
  }
  public initializeData = async () => {
    const {
      locale
    } = router;
    const [offerName] = getOffer();
    if (!locale) return;
    this.currentLocale = locale as TLocale;
    this.currentOffer = offerName;
    await this.fetchRegions(locale as TLocale);
    this.setSelectedLanguage();
  };
  private fetchRegions = async (locale: TLocale) => {
    if (!locale) return;
    const regions = await NextRegionsApi.getRegions(locale);
    runInAction(() => {
      this.regions = regions;
    });
  };
  public setExternalLanguage = async (languageObject: IRegionDataLanguage) => {
    this.currentLocale = languageObject.locale as TLocale;
    await this.fetchRegions(languageObject.locale as TLocale);
    this.setSelectedLanguage();
  };
  private setSelectedLanguage = () => {
    if (!this.regions || !Array.isArray(this.regions)) return;
    const currRegion = this.regions.find(el => el.offer === this.currentOffer);
    currRegion?.languages.forEach(language => {
      if (this.currentLocale && language.locale.includes(this.currentLocale)) {
        this.selectedLanguage = language.name;
      }
    });
  };
  public openSidebar = () => {
    this.isSideBarOpen = true;
  };
  public closeSidebar = () => {
    this.isSideBarOpen = false;
  };
}
export default RegionsStore;